<template>
  <div class="container margin_80_35">
    <div class="col-lg-12 mt-5">
      <div class="row ">
        <div class="bloglist singlepost w-100" v-if="feedback">
          <h1>{{ feedback.Subject }}</h1>
          <div class="postmeta">
            <ul>
              <li>
                <span
                  ><i class="icon_folder-alt"></i> {{ feedback.StatusStr }}
                </span>
              </li>
              <li>
                <span
                  ><i class="icon_clock_alt"></i>
                  {{
                    new Date(feedback.CreatedAt)
                      .toLocaleString()
                      .replace(",", "")
                  }}</span
                >
              </li>
                <li>
                <!-- <a href="#"
                  ><i class="icon_comment_alt"></i> ({{ feedback.Comments.length }})
                  {{ feedback.Comments.length  > 1 ? "Comments" : "Comment" }}</a
                > -->
              </li>
             
            </ul>
          </div>
          <!-- /post meta -->
          <div class="post-content">
              <p v-html="feedback.Description"></p>
          </div>
          <!-- /post -->
        </div>
         <div class="col-md-12" id="comments" v-if="feedback.Comments">
            <h5>Comments</h5>
            <ul>
            <li v-for="comment in commentList" :value="comment.Id" :key="comment.Id">
                <div class="avatar">
                <img :src="`${publicPath}assets/img/avatar.png`" alt="" />
                </div>
                <div class="comment_right clearfix">
                <div class="comment_info">
                    By <a href="#"> {{ comment.UserFullName }}</a
                    ><span>|</span>
                    {{ new Date(comment.CreatedAt).toLocaleString().replace(",", "") }}
                </div>
                <p>
                    {{ comment.Text }}
                </p>
                </div>
            </li>
            <li>
                <div class="avatar">
                 <img :src="`${publicPath}assets/img/avatar.png`" alt="" />
                </div>
                <div class="comment_right clearfix">
                <div class="form-group">
                    <textarea
                    class="form-control"
                    name="comments"
                    id="comments2" maxlength="500"
                    rows="6"
                    placeholder="Add Message"
                    v-model="commentModel.Text"
                    ></textarea>
                </div>
                <div class="form-group">
                    <button
                    type="submit"
                    id="submit2"
                    class="btn_1 rounded"
                    @click="postNewComment"
                    >
                    Submit
                    </button>
                </div>
                </div>
            </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SupportService from '../services/support-service'
import CommentsService from '../services/feedback-comments'
import Comment from '../models/Feedback-Comment.js'
export default {
  name: 'TicketDetails',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      feedback: [],
      commentList: [],
      commentModel: new Comment(this.$route.params.feedbackId)
    }
  },
  mounted() {
    if (this.$route.params.feedbackId) {
      this.getFeedbackDetails()
    }
  },
  methods: {
    getFeedbackDetails() {
      SupportService.getFeedbackbyId(this.$route.params.feedbackId).then(
        response => {
          console.log(response)
          this.feedback = response.data.Object.feedback
          this.commentList = this.feedback.Comments
        },
        error => {
          console.log(error)
        }
      )
    },
    postNewComment() {
      CommentsService.postNewComments(this.commentModel).then(
        response => {
          alert(response.data.Message, 'success')
          this.commentModel = new Comment()
          this.getFeedbackDetails()
          
        },
        error => {
          console.log(error)
        }
      )
    }
  },
}
</script>
